export default __webpack_public_path__ + "static/consistency-8354c8310bbd4e3beed30823054de290.svg";